import { memo } from "react";
import { CaloriePlanCard } from "./calorie-plan-card";

interface CaloriePlanCardsProps {
  dailyCalories: number;
  weeklyCalories: number;
}

export const CaloriePlanCards = memo(function CaloriePlanCards({
  dailyCalories,
  weeklyCalories,
}: CaloriePlanCardsProps) {
  return (
    <div className="grid grid-cols-2 gap-4 w-full">
      <CaloriePlanCard title="Daily Calories" calories={dailyCalories} />
      <CaloriePlanCard title="Weekly Calories" calories={weeklyCalories} />
    </div>
  );
});
